import NewVerificationSteps from "@/components/verification/NewVerificationSteps";

const Verification = () => {

  return <NewVerificationSteps />;
};

export default Verification;
